<template>
<div v-if="openModal">
    <Teleport  to="#teleports">
        <div class="modal fade modal-xl" data-bs-backdrop="true" id="matching-band-modal"  tabindex="-1" aria-labelledby="matching-band-modal" data-bs-tar aria-hidden="true" ref="modal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content p-lg-4">
                    <div class="modal-body">
                        <div class="title_block">
                            <h3 class="font-active" >Add a matching band:</h3>
                            <span @click="hideModal"><SvgHeaderSvg :type="'close'"  class="largesvg"/></span>
                        </div>
                        <div class="row slick_row justify-content-between">
                            <div class="col-md-12 col-lg-6">
                                <CyoBandJewelleryImageSlider v-if="images" :images="images" />
                            </div>
                            <div class="col-md-12 col-lg-5" v-if="bandDetail">
                                <h4 class="title font-active">{{ selected.product_name }}</h4>
                                <div class="price_box">
                                    <h3 class="d-flex align-items-center">{{ $formatPrice(selected.carats[0].price) }} 
                                        <span class="ms-2" v-if="!$country.is_india && selected.carats[0].discount_label">{{ $formatPrice(selected.carats[0].mrp) }}</span>
                                        <div v-if="!$country.is_india && selected.carats[0].discount_label" class="ms-2 disc_chip_pdp">{{ selected.carats[0].discount_label }}% OFF</div>
                                        <div v-if="!$country.is_india && selected.carats[0].discount_label && selected.carats[0].lowest_price_label" class="lowest_price_pdp ">Lowest Price Ever</div>
                                    </h3>
                                </div>
                                <div class="read_more">
                                    <p> {{ selected.carats[0].long_desc }}</p>
                                </div>
                                <div class="mt-4"><hr></div>
                                <div class="choose_type mt-2">
                                    <JewelryMetalDropdown
                                        :data="metals"
                                        :label="'Metals'"
                                        @toggleOption="toggleOption"
                                        :type="'metals'"
                                    />
                                </div>
                                <JewelryDropdown
                                    :type="'size'"
                                    :data="bandDetail.size"
                                    :label="sizeSelectLabel"
                                    @onSvgClick="navigateToRingSize"
                                    @toggleOption="toggleOption"
                                    :mode="errors && errors.size"
                                    ref="viewerror"
                                />
                                <div class="select_btn_block">
                                    <div class="alert alert-info mb-0" role="alert" v-if="bandDetail.availability === 0">
                                    *This item is no longer available
                                    </div>
                                    <div v-if="!loader" @click="addToCart()" class="select_button">
                                    <div>add to bag</div>
                                    </div>
                                    <div v-else class="select_button" >
                                        <span>PLEASE WAIT...</span>
                                    </div>
                                </div>
                                <CyoBandMatchingBandModalDetail :selected="selected" :item="bandDetail" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</div>
</template>
<script setup>
    import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
    import { cartStore } from '@/stores/cart/cart';

    const viewerror = ref(null);
    const store = shopdetailStore()
    const { $country, $formatPrice ,$toast, $bandDetailGtag, $bandToCartGtag} = useNuxtApp()
    const props = defineProps(['band', 'sub_type'])
    const router = useRouter()
    const bandDetail = ref(false);
    const showMore = ref(false);
    const size= ref(null);
    const update= ref(false);
    const errors= ref({});
    const has_appraisal= ref(0);
    const loader = ref(false)
    const modal = ref(null)
    const openModal = ref(false)
    const localePath = useLocalePath()
    const storeCart = cartStore()



    const sizeSelectLabel = computed(()=> {
        if($country.is_india){
            return 'select ring size (IN)'
        }
        return 'select ring size (US)'
    })
    const scrollToError = async () => {
    await nextTick();
        if (viewerror.value) {
            const dropdownEl = viewerror.value.$el || viewerror.value;
            dropdownEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };
    const selected = computed(()=>{
        if (bandDetail.value) {
            let a = bandDetail.value.metals.find( (cv) =>  cv.selected === 1 && cv.availability === 1 )
            return a
        }
        return null
    })
    const images = computed(()=>{
        if (!bandDetail.value ||  !selected.value) {
            return null
        }
        let imgs = bandDetail.value.all_images.find( (cv) => cv.color === selected.value.icon ).images
        let newObj = {}
        Object.keys(imgs).forEach(key => {
            let value = imgs[key];
            if(value){
                newObj[key] = value
            }
        });
        return newObj
    })
    const metals = computed(()=>{
        if (bandDetail.value) {
            let a = bandDetail.value.metals.filter( (cv) =>  cv.selected === 1 || cv.availability === 1 )
            return a
        }
        return null
    })
    const navigateToRingSize = ()=>{
        hideModal()
        router.push(localePath('/how-to-find-ring-size'))
    }
    const toggleOption = (type, value)=>{
        console.log(type, value,'shazam')
        if (type === 'size') {
            size.value = value
        }
    }
    const addToCart = async () => {
        if (!size.value) {
            await scrollToError(); 
            return errors.value = { ...errors.value, size:'Please select the size to proceed.' }
        }
        let item = {
            item_id: selected.value.id,
            item_type: selected.value.sub_type,
            size: size.value,
            has_appraisal: has_appraisal.value
        }
        loader.value = true
        try{
            const res = await $fetch(useCountryPath("/shop/add/session"), {
                method: 'POST',
                body: item
            })
            if(res.success){
                // this.$store.dispatch('getCartCount');
                storeCart.setCartCount()
                $toast('success', 'Congratulations!', 'Item added to cart.');
                hideModal()
                $bandToCartGtag({
                    id: bandDetail.value.id, product_name: selected.value.product_name,
                    sub_type: props.sub_type+'/'+bandDetail.value.sub_type, price: selected.value.carats[0].price
                })
            }
            
            loader.value = false
            // reload window
            window.location.reload()
        }
        catch(err){
            loader.value = false
        }
    }
    // const changeMetal = (metal)=>{
    //     bandDetail.value.kts.map( (cv) => {
    //         cv.selected = false
    //         if (cv.value === metal) {
    //             cv.selected = true
    //         }
    //     })
    // }
    const mountModal = async()=>{
        await useFetch(useCountryPath('/config/shop/detail/'+props.band.slug), )
        .then((res) => {
            // console.log(,'values res')
            bandDetail.value = res.data._value.data
        }).finally(() => {
            showModal()
        })
    }
    onMounted(async ()=>{
        await mountModal()
        await $bandDetailGtag({
            id: bandDetail.value.id, product_name: selected.value.product_name,
            sub_type: props.sub_type+'/'+bandDetail.value.sub_type, price: selected.value.carats[0].price
        })
        // console.log(bandDetail.value,'values')
    })
    const showModal = () => {
        openModal.value = true;
        nextTick(() => {
            const modalElement = modal.value;
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
            }
        });
    };
    const hideModal = () => {
        const modalElement = modal.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        openModal.value = false;
    };
    defineExpose({showModal})
</script>
<style scoped>
 
.largesvg {
    transform: scale(1.3);
}

.link{
    cursor: pointer;
}
.select_button {
    background: var(--green);
    color: #fff;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
    .select_block .invalid {
        border: 1px solid #FF0000;
    }
    button{
        background: var(--green) !important;
        border-color: none;
        text-transform: uppercase;
        font-size: 13px !important;
        border: none;
        font-weight: 600;
    }
    .btn-primary, .btn-primary:hover {
        border-color: var(--green);
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title_block{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4%;
    }
    .title_block span {
        cursor: pointer;
    }
    .title_block h3 {
        font-size: 24px;
        color: #212529;
        margin: 0;
        line-height: 1.2;
    }
    .price_box h3 span {
        color: #9A9999;
        font-size: 16px;
        text-decoration: line-through;
    }
    span.info_icon {
        color: #CCCCCC;
        margin-left: 5px;
        cursor: pointer;
    }
    h4{
        font-size: 32px;
        color: #212529;
    }
    h4, h6 {
        line-height: 1.2;
        margin-bottom: 0;
    }
    h6{
        font-size: 14px;
        font-weight: 600;
    }
    .price_box h3 {
        font-size: 24px;
        /* color: var(--green); */
        font-weight: bold;
        margin: 0;
        line-height: 1.2;
    }
    .read_more p {
        font-size: 16px;
        color: #606060;
        line-height: 1.7;
        margin: 0;
        text-align: left;
    }
    .read_more_btn {
        font-size: 16px;
        cursor: pointer;
        color: #668B84;
        font-weight: 600;
        cursor: pointer;
    }
    .title{
        margin-bottom: 16px;
    }

    .price_box {
        margin-bottom: 24px;
    }

    @media (max-width: 1100px){
        h4, .title_block h3 {
            font-size: 26px;
            line-height: normal;
        }
    }
    @media (max-width: 767px){
        h4, .title_block h3 {
            font-size: 20px;
            line-height: normal;
        }

        .title{
            margin-bottom: 8px;
        }

        h4{
            /* margin-top: 10px; */
        }

        .price_box {
            margin-bottom: 12px;
        }

        .price_box h3{
            font-size: 18px;
        }
        .read_more p {
            font-size: 14px;
        }
        .slick_row{
            padding: 0 !important;
        }
       
        .select_btn_block {
            /* position: fixed;
            bottom: 0;
            left: 0; 
            box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.15);
            background: #fff;
            z-index: 99; 
            padding: 13px;
            */
            border-radius: 8px;
            width: 100%;
        }
    }
</style>